export { default, openEditContact } from './EditContact';
